/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 从接口获取固定值的 key
 */
export enum StaticKeyE {
    /** 应用名称 */
    NAME = 'name',
    /** 命名空间 */
    NAMESPACE = 'namespace'
}

/**
 * 向导可以选择的chart名称
 * 【1.3.0版本之前-OceanProtect-DataProtect、1.3.0 之后（包括1.3.0）-DataBackup】
 */
export const ANTIRANSOMWARE_SELECT_CHART_NAME = ['OceanProtect-DataProtect', 'DataBackup'];

/**
 * 防勒索应用类型名称
 */
export const ANTIRANSOMWARE_APPLICATION_NAME = 'HyperDetect';

/**
 * 应用类型
 */
export enum ApplicationAppTypeE {
    /** 防勒索 */
    HYPER_DETECT = 'HyperDetect',
    /** 备份一体机 */
    DATA_BACKUP = 'DataBackup',
}


/**
 * 运行状态
 */
export enum ApplicationRunningStatusE {
    /** 正常运行 */
    RUNNING = 'Running'
}

/**
 * minio-chart名称
 */
export const MINIO_CHART_NAME = `minio-chart`;


